import Datepicker from './Datepicker'

import { use, registerComponent } from '../../utils/plugins'

const Plugin = {
    install(Vue) {
        registerComponent(Vue, Datepicker)
    }
}

use(Plugin)

export default Plugin

export {
    Datepicker
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/src/components/datepicker/index.js
// module id = null
// module chunks = 